export default __webpack_public_path__ + "static/media/aaaaa.f853639f.jpg";